<template>
  <main role="main">
    <meta-title :title="metaTitle"></meta-title>
    <section class="section section-default section-text">
      <div class="container m-container-only-s">
        <!-- <div v-if="$i18n.locale === 'zh'">
          <div class="content">
            <h1 class="title">Help</h1>
            <br /><br />
            <h4>
              Some movies are unavailable to me. Why?
            </h4>
            <article class="answer">
              Users, who have Android-based devices might see the 'content
              unavailable' sign on some devices.
              <br />
              <br />Your device needs to be specially prepared and checked, to
              play some of the movies. It's part of security policy of the
              studios, who provide the content onboard.
              <br />
              <br />You need to have you device prepared only once and it takes
              just a few seconds. It is important to complete preparation using
              cellular service before boarding on the plane.
              <br />
              <br />Please visit
              <a href="https://entertainment.aeroflot.ru/videobcel/?lang=en"
                >https://entertainment.aeroflot.ru/videobcel/?lang=ru</a
              >
              and play demo video that starts automatically
              <br />
              <br />
              While playing demo video, your device will be set up. Please
              pay attention that demo video has to be played on every device you
              want to use during the flight.
            </article>
            <br /><br />
            <h4>
              What are the system requirements?
            </h4>
            <br />
            <article class="answer">
              <h4>Apple Devices</h4>
              <span class="answer-subtitle"
                >Supports devices with iOS 12 and later.</span
              >
              <br /><br />
              <h4>Android Devices</h4>
              <span class="answer-subtitle">
                Supports devices with operating system versions:Android 8.0 and
                later. Google Chrome 62.0+ version is required. Devices are
                required to support Widevine L1. Widevine is software that
                allows you to protect content from piracy. To check if your
                device supports Widevine L1, download the DRM Info app.
              </span>
              <br />
              <br />
              <h4>For any device</h4>
              <span>
                Entertainment program can be played back only on devices with
                the official firmware. The playback is not guaranteed on any
                'hacked' devices (jailbroken or rooted). Due to Google
                restrictions, content playback may not be available or limited
                on certain devices from Huawei and other manufacturers.
              </span>

              <br />
              <br />

              <span>
                Technical support contact details: <br />
                Email:
                <a href="mailto:ife.aeroflot@aerogroup.ru"
                  >ife.aeroflot@aerogroup.ru</a
                >
                <br />
                Phone: 7 (495) 899-05-00
              </span>
            </article>
          </div>
        </div>
        <div v-if="$i18n.locale === 'en'">
          <div class="content">
            <h1 class="title">Help</h1>
            <br /><br />
            <h4>
              Some movies are unavailable to me. Why?
            </h4>
            <article class="answer">
              Users, who have Android-based devices might see the 'content
              unavailable' sign on some devices.
              <br />
              <br />Your device needs to be specially prepared and checked, to
              play some of the movies. It's part of security policy of the
              studios, who provide the content onboard.
              <br />
              <br />You need to have you device prepared only once and it takes
              just a few seconds. It is important to complete preparation using
              cellular service before boarding on the plane.
              <br />
              <br />Please visit
              <a href="https://entertainment.aeroflot.ru/videobcel/?lang=en"
                >https://entertainment.aeroflot.ru/videobcel/?lang=ru</a
              >
              and play demo video that starts automatically <br />
              <br />While playing demo video, your device will be set up. Please
              pay attention that demo video has to be played on every device you
              want to use during the flight.
            </article>
            <br /><br />
            <h4>
              What are the system requirements?
            </h4>
            <br />
            <article class="answer">
              <h4>Apple Devices</h4>
              <span class="answer-subtitle"
                >Supports devices with iOS 12 and later.</span
              >
              <br /><br />
              <h4>Android Devices</h4>
              <span class="answer-subtitle">
                Supports devices with operating system versions:Android 8.0 and
                later. Google Chrome 62.0+ version is required. Devices are
                required to support Widevine L1. Widevine is software that
                allows you to protect content from piracy. To check if your
                device supports Widevine L1, download the DRM Info app.
              </span>
              <br />
              <br />
              <h4>For any device</h4>
              <span>
                Entertainment program can be played back only on devices with
                the official firmware. The playback is not guaranteed on any
                'hacked' devices (jailbroken or rooted). Due to Google
                restrictions, content playback may not be available or limited
                on certain devices from Huawei and other manufacturers.
              </span>

              <br />
              <br />

              <span>
                Technical support contact details: <br />
                Email:
                <a href="mailto:ife.aeroflot@aerogroup.ru"
                  >ife.aeroflot@aerogroup.ru</a
                >
                <br />
                Phone: 7 (495) 899-05-00
              </span>
            </article>
          </div>
        </div> -->
        <div>
          <div class="content">
            <h1 class="title">{{ $t("help.title") }}</h1>
            <br />
            <br />
            <h4>
              {{ $t("help.q1") }}
            </h4>
            <article class="answer">
              {{ $t("help.q1a1") }}
              <br />
              <br />
              {{ $t("help.q1a2") }}
              <br />
              <br />
              {{ $t("help.q1a3") }}
              <br />
              <br />
              {{ $t("help.q1a4") }}
              <a href="https://entertainment.aeroflot.ru/videobcel/?lang=ru">
                https://entertainment.aeroflot.ru/videobcel/?lang=ru
              </a>
              {{ $t("help.q1a5") }}
              <br />
              <br />
              {{ $t("help.q1a6") }}
            </article>
            <br />
            <br />
            <h4>
              {{ $t("help.q2") }}
            </h4>
            <br />
            <article class="answer">
              <h4>{{ $t("help.q2a1") }}</h4>
              <span class="answer-subtitle">
                {{ $t("help.q2a2") }}
              </span>
              <br />
              <br />
              <h4>{{ $t("help.q2a3") }}</h4>
              <span class="answer-subtitle">
                {{ $t("help.q2a4") }}
              </span>
              <br />
              <br />
              <h4>{{ $t("help.q2a5") }}</h4>
              <span>
                {{ $t("help.q2a6") }}
                <br />
                <br />
                <br />
                {{ $t("help.contacts") }}
                <br />
                {{ $t("help.email") }}:
                <a href="mailto:ife.aeroflot@aerogroup.ru">
                  ife.aeroflot@aerogroup.ru
                </a>
                <br />
                {{ $t("help.phone") }}: +7 (495) 899-05-00
              </span>
            </article>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "Help",
  title() {
    return this.$t("pages.help");
  }
};
</script>

<style scoped></style>
